export class HallResearchHsm {
    constructor(socket, log) {
        this.socket = socket;
        this.maxPresets = 8;
        this.firmwareVersion = '3.30';
        this.numberOfVideoOutputs = 4;
        this.power = false;
        // Preset 0 is not used, so use that for the matrix crosspoints
        this.presets = Array(9).fill({
            videoOutputs: Array(17).fill('1'),
        });
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /FW/i,
                callback: (match) => {
                    this.socket.send(`FW Version: ${this.firmwareVersion}`);
                },
            },
            {
                name: 'setPower',
                regExp: /PW(\d)/i,
                callback: (match) => {
                    this.power = match[1] === '1' ? true : false;
                    this.socket.send(`Power${this.power ? 'ON' : 'OFF'}`);
                    if (this.power) {
                        this.socket.send(`FW Version: ${this.firmwareVersion}`);
                        this.socket.send(`PW1`);
                        for (let i = 1; i <= this.numberOfVideoOutputs; i++) {
                            this.socket.send(`CV${i},${this.presets[0].videoOutputs[i]}`);
                        }
                        this.socket.send(`LK0`);
                        this.socket.send(`BP0`);
                        this.socket.send(`IP 192.168.80.143`);
                        this.socket.send(`MAC 7a-20-0e-e4-73-10`);
                        this.socket.send(`DHCP1`);
                        this.socket.send(`************main***********`);
                    }
                },
            },
            {
                name: 'getPower',
                regExp: /PW$/i,
                callback: (match) => {
                    this.socket.send(`PW${this.power ? '1' : '0'}`);
                },
            },
            {
                name: 'presetRecall',
                regExp: /PR(\d)/i,
                callback: (match) => {
                    // Return the status for each video output in the preset
                    const presetIndex = parseInt(match[1], 10);
                    if (presetIndex <= this.maxPresets) {
                        for (let i = 1; i <= this.numberOfVideoOutputs; i++) {
                            this.socket.send(`CV${i},${this.presets[presetIndex].videoOutputs[i]}`);
                        }
                    }
                    else {
                        this.socket.send(`INVALID COMMAND`);
                    }
                },
            },
            {
                name: 'presetSave',
                regExp: /PS(\d)/i,
                callback: (match) => {
                    // Return the status for each video output in the preset
                    const presetIndex = parseInt(match[1], 10);
                    if (presetIndex <= this.maxPresets) {
                        for (let i = 1; i <= this.numberOfVideoOutputs; i++) {
                            this.presets[presetIndex].videoOutputs[i] = this.presets[0].videoOutputs[i];
                        }
                        this.socket.send(`PS${presetIndex}`);
                    }
                    else {
                        this.socket.send(`INVALID COMMAND`);
                    }
                },
            },
            {
                name: 'setRoute',
                regExp: /CV(\d+),(\d+)/i,
                callback: (match) => {
                    const videoOutputIndex = parseInt(match[1], 10);
                    this.presets[0].videoOutputs[videoOutputIndex] = match[2];
                    this.socket.send(`CV${videoOutputIndex},${match[2]}`);
                },
            },
            {
                name: 'getRoute',
                regExp: /CV$/i,
                callback: (match) => {
                    // Return the status for each video output
                    for (let i = 1; i <= this.numberOfVideoOutputs; i++) {
                        this.socket.send(`CV${i},${this.presets[0].videoOutputs[i]}`);
                    }
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`Invalid Command`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        this.numberOfVideoOutputs = Object.keys((_a = config === null || config === void 0 ? void 0 : config.videoOutputs) !== null && _a !== void 0 ? _a : {}).length;
    }
}
HallResearchHsm.emulatorType = 'socketEmulator';
HallResearchHsm.key = '-LTZIXYpaRcwn1Be2d0K';
